import { ShyScrollbar } from '@cycle-app/ui';
import styled from 'styled-components';

export const Container = styled(ShyScrollbar)`
  cursor: default;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
